import * as React from 'react';

import imgSrc from './assets/img.svg';
import * as styles from './styles.css';
import { Button, UIHeading1, UIHeading2, useUserBrowserTheme } from '@cian/ui-kit';

interface IReferralBannerProps {
  isDesktop: boolean;
  onClick: () => void;
}

export const ReferralBanner: React.FC<IReferralBannerProps> = ({ isDesktop, onClick }) => {
  const theme = useUserBrowserTheme();
  const isDarkTheme = theme === 'dark';

  const colorText = isDarkTheme ? 'text-primary-default' : 'text-inverted-default';

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        {isDesktop ? (
          <UIHeading1 color={colorText}>Порекомендуйте Сделку и&nbsp;получите 10&nbsp;000 ₽</UIHeading1>
        ) : (
          <UIHeading2 color={colorText}>Порекомендуйте Сделку и&nbsp;получите 10&nbsp;000 ₽</UIHeading2>
        )}

        <Button
          data-testid="ReferralBannerButton"
          theme="fill_white_primary"
          size="M"
          onClick={onClick}
          fullWidth={!isDesktop}
        >
          Подробнее
        </Button>
      </div>

      <div className={styles['image']}>
        <img src={imgSrc} alt="" />
      </div>
    </div>
  );
};
